import { PURGE_DATA } from './timer';

const UPDATE_PAIRS = '@@checkout/plusshipping/update_pairs';

const initialState = {
    shouldRegister: 'はい',
};

const form = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PAIRS: {
            return {
                ...state,
                ...action.pairs,
            };
        }
        case PURGE_DATA: {
            return initialState;
        }
        default:
            return state;
    }
};

export const updatePairs = pairs => ({
    type: UPDATE_PAIRS,
    pairs,
});

export default form;
